export type SlotType = 'HOME_BOTTOM_BENEFIT' | 'HOME_BOTTOM_HELP' | 'MY_PAGE_BOTTOM' | 'LOOKUP_RESULT';
export type SlotTargetType = 'INDIS' | 'CORPS' | 'PERSONAL' | 'NONE';

// 환급 홈 혜택 이벤트 광고구좌 최대 갯수
export const HOME_BOTTOM_BENEFIT_LENGTH = 3;

const stage = process.env.NEXT_PUBLIC_ZENV || 'dev';
// 광고구좌 외 다른 이미지는 dev 리소스센터 환경을 이용하지 않음
export const AD_SLOT_RESOURCE_CENTER_URL = stage === 'prd' ? process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL : 'https://dev.cdn.bznav.com';
